export const DOWNLOAD_HOST = 'blob.core.windows.net';
export const sourceHeaderValue = 'clas-web';
